import {
  FETCH_INDICES,
  FETCH_INDICES_SUCCESS,
  FETCH_INDICES_FAILURE,
  FETCH_INDEX_FAILURE,
  ADD_INDEX,
  ADD_INDEX_SUCCESS,
  ADD_INDEX_FAILURE,
  UPDATE_INDEX,
  UPDATE_INDEX_SUCCESS,
  UPDATE_INDEX_FAILURE,
  REMOVE_INDEX,
  REMOVE_INDEX_SUCCESS,
  REMOVE_INDEX_FAILURE,
} from './types'

export const fetchIndices = (accessToken) => ({
  type: FETCH_INDICES,
  payload: { accessToken },
})

export const fetchIndicesSuccess = (payload) => ({
  type: FETCH_INDICES_SUCCESS,
  payload,
})

export const fetchIndicesFailure = (payload) => ({
  type: FETCH_INDICES_FAILURE,
  payload,
})

export const fetchIndexFailure = (payload) => ({
  type: FETCH_INDEX_FAILURE,
  payload,
})

export const addIndex = (indexName, accessToken) => ({
  type: ADD_INDEX,
  payload: { indexName, accessToken },
})

export const addIndexSuccess = (payload) => ({
  type: ADD_INDEX_SUCCESS,
  payload,
})

export const addIndexFailure = (payload) => ({
  type: ADD_INDEX_FAILURE,
  payload,
})

export const updateIndex = (indexName, mapping, accessToken) => ({
  type: UPDATE_INDEX,
  payload: { mapping, indexName, accessToken },
})

export const updateIndexSuccess = (payload) => ({
  type: UPDATE_INDEX_SUCCESS,
  payload,
})

export const updateIndexFailure = (payload) => ({
  type: UPDATE_INDEX_FAILURE,
  payload,
})

export const removeIndex = (indexName, accessToken) => ({
  type: REMOVE_INDEX,
  payload: { indexName, accessToken },
})

export const removeIndexSuccess = (payload) => ({
  type: REMOVE_INDEX_SUCCESS,
  payload,
})

export const removeIndexFailure = (payload) => ({
  type: REMOVE_INDEX_FAILURE,
  payload,
})
